<template>
    <section>
        <v-container class="nav">
            <v-btn
                icon
                class="black--text"
                @click="$router.go(-1)"
            >
                <v-icon>{{ mdiArrowLeft }}</v-icon>
            </v-btn>
            <v-card-title>
                <v-row align="center">
                    <v-col
                        cols="2"
                        sm="2"
                        lg="1"
                        class="pr-0"
                        align="right"
                    >
                        <v-avatar class="page-icon teal mr-2 elevation-5">
                            <v-icon class="white--text">
                                {{ mdiHospital }}
                            </v-icon>
                        </v-avatar>
                    </v-col>
                    <v-col
                        cols="10"
                        sm="10"
                        lg="11"
                        class="pl-0"
                    >
                        <h2 style="word-break: normal;">
                            Affiliated Clinics
                        </h2>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-divider />

            <!-- Combo boxes -->
            <!-- Combo boxes -->
            <div class="comboBox d-flex justify-space-around align-center flex-wrap">
                <div class="comboWrapper d-flex">
                    <v-avatar class="teal accent-4 mr-4 elevation-5">
                        <v-icon class="white--text">
                            {{ mdiMapMarker }}
                        </v-icon>
                    </v-avatar>
                    <!-- Regions -->
                    <v-combobox
                        v-model="region"
                        color="green accent-4"
                        label="Region"
                        :items="getRegions"
                        autocomplete="nope"
                        @change="
                            (city = ''),
                            (province = ''),
                            hospClin({
                                REGION: region,
                                PROVINCE: province,
                                CITY: city,
                                TYPE: clinic,
                            }),
                            provinces({ REGION: region })
                        "
                    />
                </div>

                <!-- Provinces -->
                <div class="comboWrapper d-flex">
                    <v-avatar class="teal accent-4 mr-4 elevation-5">
                        <v-icon class="white--text">
                            {{ mdiMap }}
                        </v-icon>
                    </v-avatar>
                    <v-combobox
                        v-model="province"
                        color="green accent-4"
                        label="Province"
                        :items="getProvinces"
                        autocomplete="nope"
                        @change="
                            (city = ''),
                            hospClin({
                                REGION: region,
                                PROVINCE: province,
                                CITY: city,
                                TYPE: clinic,
                            }),
                            cities({ REGION: region, PROVINCE: province })
                        "
                    />
                </div>

                <!-- City -->
                <div class="comboWrapper d-flex">
                    <v-avatar class="teal accent-4 mr-4 elevation-5">
                        <v-icon class="white--text">
                            {{ mdiCity }}
                        </v-icon>
                    </v-avatar>
                    <v-combobox
                        v-model="city"
                        color="green accent-4"
                        label="City"
                        :items="getCities"
                        autocomplete="nope"
                        @change="
                            hospClin({
                                REGION: region,
                                PROVINCE: province,
                                CITY: city,
                                TYPE: clinic,
                            })
                        "
                    />
                </div>
            </div>
            <!-- End Combo boxes -->

            <div class="txtFieldWrapper">
                <v-text-field
                    v-model="searchClin"
                    label="Search Clinic"
                    :prepend-icon="mdiMagnify"
                    outlined
                    autocomplete="nope"
                    color="green"
                    hide-details
                />
            </div>
            <div v-if="getHospClin">
                <div style="background-color: white; padding: 3px; border-radius: 5px;">
                    <v-alert
                        color="teal darken-3"
                        outlined
                        style="margin: 0;"
                        type="info"
                    >
                        <span>Disclaimer: The accreditation status of each facility may change before updates are reflected in this list.</span>
                    </v-alert>
                </div>
                <v-data-table
                    :headers="headers"
                    :search="searchClin.toUpperCase()"
                    :items="getHospClin"
                    :items-per-page="10"
                    no-data-text
                    :footer-props="footer_props"
                    class="my-1 elevation-10"
                    :hide-headers="true"
                >
                    <template #item="{ item }">
                        <tr
                            v-if="screen_width < 600"
                            class="clinicTblRow"
                            @click="showDialog(item.hosp_name)"
                        >
                            <td colspan="7">
                                <ul class="flex-content">
                                    <div class="content d-flex justify-space-between">
                                        <label>Name</label>
                                        <li class="flex-item">
                                            {{ item.hosp_name }}
                                        </li>
                                    </div>
                                    <div class="content d-flex justify-space-between">
                                        <label>Address</label>
                                        <li class="flex-item">
                                            {{ item.hosp_address }}
                                        </li>
                                    </div>
                                    <div class="content d-flex justify-space-between">
                                        <label>City</label>
                                        <li class="flex-item">
                                            {{ item.city_name }}
                                        </li>
                                    </div>
                                    <div class="content d-flex justify-space-between">
                                        <label>Province</label>
                                        <li class="flex-item">
                                            {{ item.city_province }}
                                        </li>
                                    </div>
                                    <div class="content d-flex justify-space-between">
                                        <label>Region</label>
                                        <li class="flex-item">
                                            {{ item.hosp_region }}
                                        </li>
                                    </div>
                                </ul>
                            </td>
                        </tr>
                        <tr v-else @click="showDialog(item.hosp_name)">
                            <!-- IF Desktop View -->
                            <td v-text="item.hosp_name"></td>
                            <td v-text="item.hosp_address"></td>
                            <td v-text="item.city_name"></td>
                            <td v-text="item.city_province"></td>
                            <td v-text="item.hosp_region"></td>
                        </tr>
                    </template>
                </v-data-table>
            </div>
            <div v-else>
                <v-skeleton-loader
                    class="mx-auto"
                    width="80%"
                    type="table"
                />
            </div>

            <!-- Dialog Box -->
            <DialogBox
                :hospital="showClinic"
                :hospital-data="getHospClinDialog"
                :show="show"
                @showDialogProp="showProp"
            />
        </v-container>
    </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DialogBox from './ClinicHospitalsDialog.vue'
import { mdiArrowLeft, mdiCity, mdiHospital, mdiMagnify, mdiMap, mdiMapMarker } from '@mdi/js'
export default {
    components: { DialogBox },
    data: () => ({
        mdiArrowLeft,
        mdiHospital,
        mdiMap,
        mdiMapMarker,
        mdiCity,
        mdiMagnify,
        screen_width: document.documentElement.clientWidth + 9,
        searchClin: '',
        region: 'NCR',
        province: '',
        city: '',
        clinic: 'C',
        showClinic: null,
        show: false,
        footer_props: {
            'items-per-page-options': []
        },
        headers: [
            {
                text: 'Name',
                align: 'left',
                value: 'hosp_name',
                class: 'teal--text'
            },
            {
                text: 'Address',
                align: 'left',
                sortable: false,
                value: 'hosp_address',
                class: 'teal--text'
            },
            {
                text: 'City',
                align: 'left',
                value: 'city_name',
                class: 'teal--text'
            },
            {
                text: 'Province',
                align: 'left',
                value: 'city_province',
                class: 'teal--text'
            },
            {
                text: 'Region',
                align: 'left',
                value: 'hosp_region',
                class: 'teal--text'
            }
        ]
    }),
    computed: {
        ...mapGetters(['getRegions', 'getProvinces', 'getCities', 'getHospClin', 'getHospClinDialog']),
        getAllHospClin: {
            get() {
                return this.getHospClin
            }
        }
    },
    mounted(){
        window.addEventListener('resize', this.onResize)
    },
    destroyed(){
        window.removeEventListener('resize', this.onResize)
    },
    created() {
        this.regions()
        this.provinces({ REGION: this.region })
        this.hospClin({
            REGION: this.region,
            PROVINCE: this.province,
            CITY: this.city,
            TYPE: this.clinic
        })
    },
    methods: {
        ...mapActions(['regions', 'provinces', 'cities', 'hospClin', 'hospClinDialog', 'getCsrfToken']),
        map_hospClin_code(hosp_name) {
            const all = this.getAllHospClin
            const item = all.find((param) => {
                return param.hosp_name === hosp_name
            })
            return item.hosp_msu_code
        },
        async showDialog(name) {
            this.showClinic = name
            await this.hospClinDialog({
                PTYPE: 'C',
                HOSP_MSU: this.map_hospClin_code(name),
                SPEC: ''
            })
            this.showProp(true)
        },
        showProp(show) {
            this.show = show
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
            this.screen_width = this.screen_width + 9
        }
    }
}
</script>

<style scoped>
section {
  background-image: url("../../../assets/dashboardBG.webp");
  background-position: center;
  background-size: cover;
}
.clinicTblRow td ul div li {
    min-height: 40px;
    height: auto;
    padding-top: 10px;
}
.clinicTblRow td ul div label {
    padding-top: 10px;
    font-weight: 600;
}
.clinicTblRow td ul div {
    width: 100%;
}
.txtFieldWrapper {
  width: 60%;
  margin: 20px auto;
}
.comboWrapper {
  width: 20%;
  margin: 20px 0px 0px 0px;
}

@media (max-width: 390px) {
  .page-icon {
    display: none;
  }
}

@media (max-width: 599px) {
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }

  .comboWrapper,
  .txtFieldWrapper {
    width: 90%;
  }
}

.flex-content {
    padding: 0;
    margin: 10px auto;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
}

.flex-item {
    padding: 5px;
    width: 100%;
    height: 40px;
    text-align: right;
}

@media (min-width: 599px) and (max-width: 968px) {
  @media (min-width: 599px) and (max-width: 968px) {
    /* Navbar */
    .nav {
      margin-top: 60px;
    }
    .nav h2 {
      font-size: 25px;
    }

    .comboWrapper,
    .txtFieldWrapper {
      width: 60%;
    }
  }
}
table tr td {
  cursor: pointer;
}
</style>
